import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-sign-in-detected-template',
  styleUrls: ['../../global-styles.less', './sign-in-detected.component.less'],
  templateUrl: './sign-in-detected.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class SignInDetectedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<SignInDetectedTemplateData>;
}

export type SignInDetectedTemplateData = {
  title: string;
  p1_html: string;
  p2_html: string;
  detail_1?: string;
  detail_2?: string;
  detail_3?: string;
  detail_4?: string;
  footer: string;
  support_email: string;
};

export const SignInDetectedTemplateMocks: SignInDetectedTemplateData[] = [
  {
    title: 'New sign-in detected',
    p1_html:
      'We have detected a new sign-in to your Recruitee account (<a href="mailto:john.doe@recruitee.com">john.doe@recruitee.com</a>).',
    p2_html: `If this was you, you can ignore this message. If you don’t recognize this activity, please change your password immediately.<br /><br />We also recommend activating two-factor authentication (2FA) to increase account security and prevent unauthorized access.`,
    detail_1: 'Date and time: 2023-06-13 08:07:20 UTC',
    detail_2: 'Device: Chrome/MacOS',
    detail_3: 'IP Address: 178.47.128.80',
    detail_4: 'Location: Berlin, Germany',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
